import React from 'react';
import Button from './Button';
import { ReactComponent as PromptLogo2 } from '../assets/prompt-logo-2.svg';

export default function SignUpBanner() {
  return (
    <section className='flex items-center justify-center py-26'>
      <div className='flex flex-col items-center gap-6'>
        <div className='flex items-center justify-center bg-white/16 rounded-3xl w-[5.5rem] h-[5.5rem]'>
          <PromptLogo2 className='w-16 h-16' />
        </div>
        <div className='space-y-4 text-center'>
          <h2 className='text-4.5xl font-semibold leading-[141%]'>
            Unleash your agent
          </h2>
          <p className='text-white/60 text-lg md:text-base'>
            Omni-chain tool for AI-blockchain interaction.
          </p>
        </div>
        <Button color='gray' size='lg' href='https://app.wayfinder.ai/signup'>
          Sign Up
        </Button>
      </div>
    </section>
  );
}
